import { useEffect, useRef } from "react";
import './CustomPhoneNumber.css';

const CustomPhoneNumberField = ({
  countryCode,
  phoneNumber,
  name,
  handleCountryCode,
  handlePhoneNumberChange,
  placeholder
}) => {
  const inputRef = useRef(null);
  const itiRef = useRef(null);
  const resolvedCountry =
    typeof countryCode === "string"
      ? countryCode
      : countryCode?.countryCode || "th";
  useEffect(() => {
    if (window.intlTelInput && inputRef.current) {
      itiRef.current = window.intlTelInput(inputRef.current, {
        initialCountry: resolvedCountry,
        separateDialCode: true,
        preferredCountries: ['in', 'th'],
        utilsScript:
          "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js",
      });

      inputRef.current.addEventListener("countrychange", handleCountryChange);
    }

    return () => {
      if (inputRef.current) {
        inputRef.current.removeEventListener("countrychange", handleCountryChange);
      }
      if (itiRef.current) {
        itiRef.current.destroy();
      }
    };
  }, []);
useEffect(() => {
  if (itiRef.current && typeof countryCode === "string") {
    itiRef.current.setCountry(countryCode);
  }
}, [countryCode]);
  const handleChange = () => {
    if (itiRef.current) {
      emitPhoneNumberChange("input");
    }
  };

  const handleCountryChange = () => {
    if (itiRef.current) {
      emitPhoneNumberChange("country");
    }
  };


  const emitPhoneNumberChange = (triggeredBy = "input") => {
    const fullNumber = itiRef.current.getNumber();
    const countryData = itiRef.current.getSelectedCountryData();
    const dialCode = `+${countryData.dialCode}`;
    const nationalNumber = inputRef.current.value;

    if (triggeredBy === "country") {
      handleCountryCode && handleCountryCode({
        dialCode,
        countryCode: countryData.iso2,
      });
    } else if (triggeredBy === "input") {
      handlePhoneNumberChange && handlePhoneNumberChange({
        fullNumber,
        dialCode,
        nationalNumber,
        countryCode: countryData.iso2,
      });
    }
  };


  return (
    <div >
      <input
        name={name}
        value={phoneNumber}
        type="tel"
        id="mobile_code"
        className="form-control"
        placeholder={placeholder || "Phone Number"}
        ref={inputRef}
        onChange={handleChange}
      />
    </div>
  );
};

export default CustomPhoneNumberField;
